import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import { Field } from '@components/framework/formfield/Field.tsx';
import * as yup from 'yup';
import { ValidationError } from 'yup';
import { findValidationMessage, hasValidationProblemForPrefix } from '@utils/validation.tsx';
import useForm from '@hooks/useForm/useForm.tsx';
import { isNotBlank, isNotNullOrUndefined } from '@utils/utils.tsx';
import SvgCoins from '@icons/Coins.tsx';
import { InputText } from 'primereact/inputtext';
import SvgNumber from '@icons/Number.tsx';

export interface CustomsMRNData {
  mrnNumber?: string;
}

interface ComponentProps {
  value: string;
  onChange: (value: string) => void;
  readonly?: boolean;
  validationErrors?: ValidationError[];
  validationPrefix?: string;
  secured?: SecuredConfig;
}

export const CustomsMRNValidationSchema = () => {
  return yup.object().nullable().shape({});
};

const CustomsMRNsTag: React.FC<ComponentProps> = ({ value, onChange, readonly, validationPrefix, validationErrors, secured }) => {
  const { tr } = useTranslationLgs();

  const form = useForm<CustomsMRNData>(
    CustomsMRNValidationSchema(),
    isNotBlank(value) ? { mrnNumber: value } : null,
    (d, onSuccess) => {
      if (isNotNullOrUndefined(onSuccess)) {
        onSuccess();
      }
      onChange(isNotBlank(d?.mrnNumber) ? d.mrnNumber : null);
    },
    false,
    false
  );

  const hasError = validationErrors && validationPrefix ? hasValidationProblemForPrefix(validationErrors, validationPrefix) : false;

  return (
    <>
      <ButtonTag
        label={tr("CustomsMRNTag.cisloMrn", "Číslo MRN")}
        icon={<SvgNumber />}
        value={value}
        readonly={readonly}
        secured={secured}
        popupWidth={'300px'}
        errorMessage={hasError ? tr(`CustomsMRNsTag.validationError`, `Validation error`) : undefined}
        onSave={(onSuccess) => {
          form.validateAndSendWithSuccess(onSuccess);
        }}
        onClose={() => {
          form.clear();
        }}
        autoClose>

        <>
          <Field label={tr("CustomsMRNTag.cisloMrn", "Číslo MRN")} errorMessage={findValidationMessage(validationErrors, 'status', tr)}>
            <InputText value={form.values?.mrnNumber} onChange={(e) => form.setFieldValue('mrnNumber', e.target.value)} />
          </Field>
        </>
      </ButtonTag>
    </>);

};

export default CustomsMRNsTag;